import { render, staticRenderFns } from "./ProjectRow.vue?vue&type=template&id=3ff827f0&scoped=true&lang=pug&"
import script from "./ProjectRow.vue?vue&type=script&lang=js&"
export * from "./ProjectRow.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRow.vue?vue&type=style&index=0&id=3ff827f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff827f0",
  null
  
)

export default component.exports